import React, { useContext } from "react";
import ArtistTile from "./ArtistTile.js";
import { CurrentPlaylistContext } from "../contexts/CurrentPlaylistContext";

const CatalogCard = (props) => {
  const { setCurrentPlaylist, artists } = useContext(CurrentPlaylistContext);

  const setPlaylist = (id) => {
    setCurrentPlaylist(id);
    props.handleClose();
  };

  return (
    <>
      <div className="container">
        <div className="row">
          {artists
            ? artists.map((artist, index) => (
                <ArtistTile
                  key={index}
                  artist={artist}
                  onClick={() => setPlaylist(artist.id)}
                />
              ))
            : "Loading..."}
        </div>
      </div>
    </>
  );
};

export default CatalogCard;


